import { Icon } from '#/components/Icon/Icon';
import type { IconName } from '#/components/Icon/IconName';
import { TagSimple } from '#/components/Tag/TagSimple';
import type { Color } from '#/theme/theme';
import { colors } from '#/theme/theme';

type Props = {
  iconName: IconName;
  text: string;
  badgeColor?: Color;
  textColor?: Color;
};

export function OrgStatBadge({
  iconName,
  text,
  badgeColor = 'lemon',
  textColor = 'mediumContentGrey',
}: Props) {
  return (
    <TagSimple
      $color={colors[textColor]}
      $bg={colors[badgeColor]}
      $borderColor={colors[badgeColor]}
    >
      <div style={{ display: 'flex' }}>
        <div style={{ paddingRight: '6px', display: 'inline' }}>
          <Icon name={iconName} colorName={textColor} size={12} />
        </div>
        <span>{text}</span>
      </div>
    </TagSimple>
  );
}
